interface PasswordAuthEnv {
  VITE_PASSWORD_AUTH_ENABLED?: string
  VITE_TURNSTILE_SITE_KEY?: string
}

function isTruthy(value?: string): boolean {
  if (!value) return false
  return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase())
}

function isLocalHostname(value?: string): boolean {
  if (!value) return false
  const normalized = value.toLowerCase()
  return (
    normalized === 'localhost' ||
    normalized === '127.0.0.1' ||
    normalized === '0.0.0.0' ||
    normalized.endsWith('.localhost')
  )
}

export function isPasswordAuthEnabled(env: PasswordAuthEnv = import.meta.env): boolean {
  return isTruthy(env.VITE_PASSWORD_AUTH_ENABLED)
}

export function getTurnstileSiteKey(
  env: PasswordAuthEnv = import.meta.env,
  hostname = typeof window !== 'undefined' ? window.location.hostname : undefined
): string | null {
  if (isLocalHostname(hostname)) {
    return null
  }

  const siteKey = env.VITE_TURNSTILE_SITE_KEY?.trim()
  return siteKey ? siteKey : null
}
